/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'yes' }, { id: 'sometimes' }, { id: 'curious' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-wonder"
      progress={5}
      field="hairstyleWonder"
      setter="setHairstyleWonder"
      ns="hairstyleWonder"
      options={OPTIONS}
      imageName="hairstyleWonder"
    />
  );
}

export default Page;
